import { lazier } from '@shared/components';

export const ActivityLogs = lazier(() => import('./ActivityLogs'), false);

export { default as ActivityActionsMenu } from './ActivityActionsMenu';

export { default as CreateActivityForm } from './CreateActivityForm';
